import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { CgMail } from "react-icons/cg";
import { ImProfile } from "react-icons/im";
// import '../../style.css';

const Contact = () => {
    const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_7bmkd5p', 'template_nv81g3e', e.target, 'baGNdiLvMH9olYzXa')
            .then((result) => {
                console.log('Success:', result.text);  
                setStatus('Message sent successfully!');
                setFormData({ name: '', email: '', subject: '', message: '' }); 
            }, (error) => {
                console.error('Error:', error.text);  
                setStatus('Failed to send message.');
            });
    };

    return (
        <>
            <div className="contact-container">
                <div className="letsconnect" style={{ marginBottom: '30%' }}>
                    {/* Optional content for "Let's connect" can be added here */}
                </div>
                <div className="contact-form">
                    <div className="form-left">
                        <h2 style={{ marginBottom: '10%' }}>Get in touch</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange} required></textarea>
                            </div>
                            <button type="submit" style={{backgroundColor:'blue',color:'white'}}>Send Message</button>
                            {status && <p>{status}</p>}
                        </form>
                    </div>
                    <div className="form-right">
                        <h2>Contact</h2>
                        <ul>
                            <li>
                           < CgMail />
                                <span style={{marginLeft:'5%'}}>
                                    <a href="mailto:shivakumarhm9353@gmail.com" target="_blank" rel="noopener noreferrer">
                                        Email
                                    </a>
                                </span>
                            </li>
                            <li>
                      <FaLinkedin />
                                <span style={{marginLeft:'5%'}}>
                                    <a href="https://www.linkedin.com/in/shivakumar-h-m-107288212/" target="_blank" rel="noopener noreferrer">
                                        LinkedIn
                                    </a>
                                </span>
                            </li>
                            <li>
                                <FaGithub />
                                <span style={{marginLeft:'5%'}}>
                                    <a href="https://github.com/Shiva-from-Hanchihalli" target="_blank" rel="noopener noreferrer">
                                        GitHub
                                    </a>
                                </span>
                            </li>
                            <li>
                            < ImProfile />
                                <span style={{marginLeft:'5%'}}>
                                    <a href="https://shivanewweb.netlify.app/" target="_blank" rel="noopener noreferrer">
                                        Portfolio
                                    </a>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default Contact;
